export default __webpack_public_path__ + "static/media/Zebra Technologies.a3342dc6.png";